module.exports = __webpack_public_path__ + "img/2.cc6434b6.png";